// client/src/lib/listTools.js
// Small helpers behind the shared ListToolbar: free-text matching and a
// stable multi-type sort. Lists that live fully on the client (students,
// leaderboard, devices, classes, managers) use both; server-paginated lists
// (transactions) only use the toolbar's state and forward it as query params.

/** Case-insensitive "any of these fields contains q". Empty q → everything. */
export function matchesText(row, q, fields) {
  const needle = String(q || '').trim().toLowerCase();
  if (!needle) return true;
  return fields.some((f) => {
    const v = typeof f === 'function' ? f(row) : row[f];
    return v != null && String(v).toLowerCase().includes(needle);
  });
}

/**
 * Sort a copy of `rows` by `sort.key` using `getters[key](row)`.
 * Numbers / Dates compare numerically, strings via Hebrew-aware localeCompare,
 * null/undefined always sink to the end regardless of direction.
 */
export function sortRows(rows, sort, getters) {
  const get = getters[sort?.key];
  if (!get) return rows;
  const dir = sort.dir === 'asc' ? 1 : -1;
  return [...rows].sort((a, b) => {
    const va = get(a);
    const vb = get(b);
    const na = va == null || va === '';
    const nb = vb == null || vb === '';
    if (na && nb) return 0;
    if (na) return 1;
    if (nb) return -1;
    if (va instanceof Date || vb instanceof Date) {
      return (new Date(va).getTime() - new Date(vb).getTime()) * dir;
    }
    if (typeof va === 'number' && typeof vb === 'number') return (va - vb) * dir;
    if (typeof va === 'boolean' && typeof vb === 'boolean') return ((va ? 1 : 0) - (vb ? 1 : 0)) * dir;
    return String(va).localeCompare(String(vb), 'he', { numeric: true }) * dir;
  });
}
